<template>
  <el-dialog
    :title="globalMode ? '系统预设属性设置' : '类目属性设置'"
    :visible="visible"
    width="92%"
    top="4vh"
    class="custom-el-wrapper"
    custom-class="doudian-category-attribute-dialog"
    :close-on-click-modal="false"
    :before-close="handleBeforeClose"
    @open="handleOpen"
  >
    <category-attribute-editor
      ref="editor"
      :shop-id="shopId"
      :template-id="templateId"
      :global-mode="globalMode"
      @dirty-change="editorDirty = $event"
      @saving-change="editorSaving = $event"
      @category-change="editorCanSave = $event"
      @saved="$emit('saved', $event)"
    />
    <span slot="footer">
      <el-button @click="requestClose">关闭</el-button>
      <el-button type="primary" :loading="editorSaving" :disabled="!editorCanSave" @click="saveConfig">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CategoryAttributeEditor from '../../shopManage/components/CategoryAttributeEditor.vue'

export default {
  name: 'CategoryAttributeDialog',
  components: { CategoryAttributeEditor },
  props: {
    visible: { type: Boolean, default: false },
    shopId: { type: Number, required: true },
    templateId: { type: [Number, String], required: true },
    globalMode: { type: Boolean, default: false }
  },
  data() {
    return {
      editorDirty: false,
      editorSaving: false,
      editorCanSave: false
    }
  },
  watch: {
    visible(value) {
      if (!value) {
        this.editorDirty = false
        this.$nextTick(() => {
          if (this.$refs.editor) this.$refs.editor.deactivate()
        })
      }
    }
  },
  methods: {
    handleOpen() {
      this.$nextTick(() => {
        if (this.$refs.editor) this.$refs.editor.initialize()
      })
    },
    saveConfig() {
      if (this.$refs.editor) this.$refs.editor.saveConfig()
    },
    discardDirty() {
      this.editorDirty = false
      if (this.$refs.editor) this.$refs.editor.discardDirty()
    },
    finishClose(done) {
      this.discardDirty()
      if (this.$refs.editor) this.$refs.editor.deactivate()
      if (done) done()
      this.$emit('update:visible', false)
    },
    requestClose() {
      this.handleBeforeClose()
    },
    handleBeforeClose(done) {
      if (!this.editorDirty) {
        this.finishClose(done)
        return
      }
      this.$confirm('存在未保存的类目属性，确认关闭？', '提示', { type: 'warning' })
        .then(() => this.finishClose(done))
        .catch(() => {})
    }
  }
}
</script>

<style>
.doudian-category-attribute-dialog{font-size:13px}.doudian-category-attribute-dialog .el-dialog__header{padding:18px 20px 12px}.doudian-category-attribute-dialog .el-dialog__title{font-size:17px;line-height:24px}.doudian-category-attribute-dialog .el-dialog__body{padding-top:10px}.doudian-category-attribute-dialog .el-input__inner{height:36px;font-size:13px;line-height:36px}.doudian-category-attribute-dialog .el-input__icon{line-height:36px}.doudian-category-attribute-dialog .el-checkbox__label,.doudian-category-attribute-dialog .el-radio__label,.doudian-category-attribute-dialog .el-button{font-size:13px}.doudian-category-attribute-dialog .el-dialog__footer{border-top:1px solid #ebeef5}.doudian-property-image-tooltip{max-width:420px;line-height:22px;white-space:normal}.doudian-property-image-tooltip .image-tooltip-title{margin-bottom:4px;font-weight:600}
.doudian-category-sync-dialog .el-dialog__title{font-size:16px}.doudian-category-sync-dialog .el-dialog__body{padding-top:12px}.doudian-category-sync-dialog .el-dialog__footer{border-top:1px solid #ebeef5}
</style>
